import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ek5cbm3l: FaireBrandEntity = {
  token: "b_ek5cbm3l",
  type: "brand",
  name: "Imi jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/9cc7a7deac13d53f9fd082b8ea756a9523e6f68edb22aaaccf75d6b772616f28.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c655feba72a2f984172788a52e8738cbe9cdebd1b6eef1435ae1b203ad764b24.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9cc7a7deac13d53f9fd082b8ea756a9523e6f68edb22aaaccf75d6b772616f28.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c655feba72a2f984172788a52e8738cbe9cdebd1b6eef1435ae1b203ad764b24.jpeg",
  location: "Honolulu, HI, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 2,
  isInsider: false,
  description:
    'Imi, pronounced "ee-mee" translated in Hawaiian means "to seek" or "to hunt." In Japanese, imi is translated to "meaning." Inspired by her surroundings, designer Lauren Yamashita of Honolulu, Hawaii created Imi Jewelry to express her overflowing creativity and her love of simplicity. Imi Jewelry is a reflection of Lauren’s personal style and growth. Pieces are meant to be comfortable to wear, and complement the wearer’s natural beauty.  Imi focuses on “dainty statement” designs. ',
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:13.173Z",
    importedBy: "entity-db-cli",
  },
};
